import React from "react";

import Table from "components/Table";
import { orderInvoicesColumns } from "./columns";

interface IProps {
  isLoading: boolean;
  loadData: () => void;
  data: any[];
  onRowClick: (any) => void;
}

class OrderInvoices extends React.PureComponent<IProps> {
  public componentDidMount() {
    this.props.loadData();
  }

  public render() {
    const { data, isLoading, onRowClick } = this.props;

    return (
      <Table
        columns={orderInvoicesColumns}
        dataSource={data}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    );
  }
}

export default OrderInvoices;
